import script from "./TokenInfos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenInfos.vue?vue&type=script&setup=true&lang=ts"

import "./TokenInfos.vue?vue&type=style&index=0&id=13c91bba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c91bba"]])

export default __exports__